import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from 'js/components/design-system';
import { caseBreadcrumbsHistory } from './functions';

const CaseBreadcrumbs = () => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <Breadcrumbs
      className="case-breadcrumbs"
      history={caseBreadcrumbsHistory(t, location)}
    />
  );
};

export default CaseBreadcrumbs;
